export default "__VITE_ASSET__UoEwzkCX__"